export default __webpack_public_path__ + "static/media/avatar10.1683e1c0.png";